import { useEffect, useState } from "react";
import { web } from "../lib/api";

let cache = null;
const load = () => (cache ??= web.get("/site/invite-website").then((r) => r.data?.url).catch(() => null));
export const refreshInviteWebsite = () => { cache = null; };

/** Admin-set website address that goes in every invite (falls back to this app's home page). */
export function useInviteWebsite() {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let live = true;
    load().then((u) => { if (live) setUrl(u || window.location.origin); });
    return () => { live = false; };
  }, []);
  return url ?? window.location.origin;
}

export const siteLabel = (url) => url.replace(/^https?:\/\//, "").replace(/\/$/, "");
